// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2S3Wo","header":"PatientBlock_header__3A__V","label":"PatientBlock_label__TQdNH","option":"PatientBlock_option__2F1X-"};